import React from 'react';
import { useTranslation } from 'react-i18next';

import Loading from '../../components/Loading';
import { LanguageSelect } from './LanguageSelect';
import Button from '../../components/Button/Button';
import { Input } from '../../components/Input';

export const Language = ({ loading, formik }) => {
    const { t } = useTranslation();
    const onChange = (e) => {
        formik.setFieldValue(formik.values.language, { ...(formik.values[formik.values.language] || {}), [e.target.name]: e.target.value });
    };

    return (
        <Loading loading={loading}>
            <div className="pt-2 px-5" style={{ minHeight: '80vh' }}>
                <p className="my-2 text-xl font-bold">{t('Languages')}</p>

                <div className="mr-48 pt-2 pb-4 font-medium text-sm">
                    {t('Please add/edit and save your menu item names and descriptions in the supported languages (Armenian, English and Russian). Your customers will then be able to switch language settings on your app.')}
                </div>

                <div className="w-5/12">
                    <div className="col-span-3 sm:col-span-3 py-1 mb-1">
                        <label className="block text-sm font-bold text-black-800 mb-1">{t('Choose Language')}</label>
                        <LanguageSelect name="language" formik={formik} />
                    </div>

                    <div className="col-span-3 sm:col-span-3 py-1 mb-1">
                        <label className="block text-sm font-bold text-black-800">{t('Name')}</label>

                        <Input
                            type="text"
                            value={formik.values[formik.values.language]?.title}
                            onChange={onChange}
                            name="title"
                            placeholder={t('Name')}
                            className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                        />
                    </div>

                    <div className="col-span-3 sm:col-span-3 py-1 mb-1">
                        <label className="block text-sm font-bold text-black-800">{t('Description')}</label>
                        <div className="mt-1">
                            <Input
                                as="textarea"
                                id="description"
                                value={formik.values[formik.values.language]?.description}
                                onChange={onChange}
                                name="description"
                                rows="4"
                                placeholder={t('Description')}
                                className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                            />
                        </div>
                    </div>

                    <div className="py-3 text-right">
                        <Button type="submit" isLoading={loading} className="font-bold">
                            {t('Save')}
                        </Button>
                    </div>
                </div>
            </div>
        </Loading>
    );
};
